import { useEffect, useState } from "react";
import Content from "../../template/content";
import Post from "../../components/post";
import { Post as PostProps} from "../../types/Post";
import { getPosts } from "../../data/Post";
import styled from 'styled-components'

const Wall = styled.div`
@-webkit-keyframes building-blocks {
	0%,
	20% {
	  opacity: 0;
	  -webkit-transform: translateY(-300%);
			  transform: translateY(-300%); }
	30%,
	70% {
	  opacity: 1;
	  -webkit-transform: translateY(0);
			  transform: translateY(0); }
	90%,
	100% {
	  opacity: 0;
	  -webkit-transform: translateY(300%);
			  transform: translateY(300%); } }
  @keyframes building-blocks {
	0%,
	20% {
	  opacity: 0;
	  -webkit-transform: translateY(-300%);
			  transform: translateY(-300%); }
	30%,
	70% {
	  opacity: 1;
	  -webkit-transform: translateY(0);
			  transform: translateY(0); }
	90%,
	100% {
	  opacity: 0;
	  -webkit-transform: translateY(300%);
			  transform: translateY(300%); } }
  
	position: relative; 
	 div {
	  height: 20px;
	  position: absolute;
	  width: 20px; }
	   div:after {
		-webkit-animation: building-blocks 2.1s ease infinite backwards;
				animation: building-blocks 2.1s ease infinite backwards;
		background: #707070;
		content: '';
		display: block;
		height: 20px;
		width: 20px; }
	   div:nth-child(1) {
		-webkit-transform: translate(-50%, -50%) translate(60%, 120%);
				transform: translate(-50%, -50%) translate(60%, 120%); }
	   div:nth-child(2) {
		-webkit-transform: translate(-50%, -50%) translate(-60%, 120%);
				transform: translate(-50%, -50%) translate(-60%, 120%); }
	   div:nth-child(3) {
		-webkit-transform: translate(-50%, -50%) translate(120%, 0);
				transform: translate(-50%, -50%) translate(120%, 0); }
	   div:nth-child(4) {
		-webkit-transform: translate(-50%, -50%);
				transform: translate(-50%, -50%); }
	   div:nth-child(5) {
		-webkit-transform: translate(-50%, -50%) translate(-120%, 0);
				transform: translate(-50%, -50%) translate(-120%, 0); }
	   div:nth-child(6) {
		-webkit-transform: translate(-50%, -50%) translate(60%, -120%);
				transform: translate(-50%, -50%) translate(60%, -120%); }
	   div:nth-child(7) {
		-webkit-transform: translate(-50%, -50%) translate(-60%, -120%);
				transform: translate(-50%, -50%) translate(-60%, -120%); }
	 div:nth-child(1):after {
	  -webkit-animation-delay: 0.15s;
			  animation-delay: 0.15s; }
	 div:nth-child(2):after {
	  -webkit-animation-delay: 0.3s;
			  animation-delay: 0.3s; }
	 div:nth-child(3):after {
	  -webkit-animation-delay: 0.45s;
			  animation-delay: 0.45s; }
	 div:nth-child(4):after {
	  -webkit-animation-delay: 0.6s;
			  animation-delay: 0.6s; }
	 div:nth-child(5):after {
	  -webkit-animation-delay: 0.75s;
			  animation-delay: 0.75s; }
	 div:nth-child(6):after {
	  -webkit-animation-delay: 0.9s;
			  animation-delay: 0.9s; }
	 div:nth-child(7):after {
	  -webkit-animation-delay: 1.05s;
			  animation-delay: 1.05s; }
`

const Portfolio = () => {
    const [currentPage, setCurrentPage] = useState(0);
    const [posts, setPosts] = useState<PostProps[]>([]);
    const [loading, setLoading] = useState(false);
    const [itensPerPage, setItensPerPage] = useState(4);
    const startIndex = currentPage * itensPerPage;
    const pages = Math.ceil(posts.length / itensPerPage);
    const endIndex = startIndex + itensPerPage
    const currentItens = posts.slice(startIndex, endIndex);
    
    useEffect(()=>{
        const getPortfolio = async () => {
          setLoading(true)
          setPosts(await getPosts())
		  setLoading(false)
        }
        try{
            getPortfolio();
        } catch (error) {
            alert(error);
        }
    }, []);

    return(
        <Content>
            {loading &&
                <div className="loader-container">
					<Wall>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</Wall>
                </div>
            }
            {!loading && posts.length > 0 &&
                <div className="d-flex justify-content-center mt-4 mt-lg-2">
                    <div className="container-xxl">
                        {currentItens.map((item, index) => (
                            <>
                            {index%2===0 &&
                                <div key={index}>
                                <Post content={item}  align='' textAlign='text-md-start' key={item.id}/>
                                <hr className="my-5"/>
                                </div>
                            }
                            {index%2!==0 &&
                                <div key={index}>
                                <Post content={item} align='order-md-2' textAlign='text-md-end' key={item.id}/>
                                <hr className="my-5"/>
                                </div>
                            }  
                            </>
                        ))}
                    </div>
                </div> 
            }
            {!loading &&
                <div className="d-flex justify-content-center mt-2">
                    <ul className="pagination">
                        <li className="page-item">
                            <button onClick={(e) => setCurrentPage(currentPage-1)} className={`btn btn-light ${currentPage === 0 ? 'disabled' : ''} p-2 me-1`} ><i className="bi bi-caret-left-fill"></i></button>
                        </li>
                        <li className="page-item">
                            <button onClick={(e) => setCurrentPage(currentPage+1)} className={`btn btn-light ${currentPage === pages-1 ? 'disabled' : ''} p-2 ms-1`}><i className="bi bi-caret-right-fill"></i></button>
                        </li>
                    </ul>
                </div>    
            }       
        </Content>
    )
}

export default Portfolio;